var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickFiltersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21498",
    "data-name": "Group 21498",
    transform: "translate(-1147 -331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter_alt-24px",
    transform: "translate(1147 331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21496",
    "data-name": "Group 21496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14131",
    "data-name": "Path 14131",
    d: "M0,0H24m0,24H0",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14133",
    "data-name": "Path 14133",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tune_24dp_FILL0_wght400_GRAD0_opsz24",
    d: "M127.072-824.087v-5.3h1.768v1.768h7.072v1.768h-7.072v1.768ZM120-825.855v-1.768h5.3v1.768Zm3.536-3.536v-1.768H120v-1.768h3.536V-834.7H125.3v5.3Zm3.536-1.768v-1.768h8.841v1.768Zm3.536-3.536V-840h1.768v1.768h3.536v1.768h-3.536v1.768ZM120-836.464v-1.768h8.841v1.768Z",
    transform: "translate(-115.957 844.043)",
    fill: "#7a89a0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickFiltersIcon);
export default __webpack_public_path__ + "static/media/quick-filters-icon.8b5eede62d00fbb5504c4ce0459a5e44.svg";
export { ForwardRef as ReactComponent };